import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CredentialsCurrentUser } from '@app/core';
import {
    from,
    map,
    Observable,
    of,
    ReplaySubject,
    switchMap,
    take,
    tap,
    throwError
} from 'rxjs';
import { UserService } from '@services/index';

interface Credentials {
    tokens: any;
    data: any[];
    user: any;
    role: string;
    company: Object;
    isCoupa: boolean;
    coupaURL: string;
    reservation_allowed: boolean;
    buyerCookie: string;
    clientId?: string;
}

// Generated by https://quicktype.io

export interface CognitoJWT {
    sub: string;
    email_verified: boolean;
    iss: string;
    'cognito:username': string;
    origin_jti: string;
    aud: string;
    event_id: string;
    token_use: string;
    auth_time: number;
    name: string;
    exp: number;
    iat: number;
    jti: string;
    email: string;
}

@Injectable({ providedIn: 'root' })
export class UserAuthService {
    private _httpClient = inject(HttpClient);
    private _user: ReplaySubject<CredentialsCurrentUser> = new ReplaySubject<
        CredentialsCurrentUser
    >(1);
    private _credentials: Credentials;

    constructor() {}
    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: CredentialsCurrentUser) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<CredentialsCurrentUser> {
        return this._user.asObservable();
    }
}
